import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SaleForm from '../ui/saleForm';

const AddSale = () => {
    const navigate = useNavigate();
    const [billTo, setBillTo] = useState('');
    const [items, setItems] = useState([
        {
            item: '',
            qty: 1,
            discount: '',
            discountType: '%',
            hsnCode: '',
            unit: '',
            taxRate: '',
        },
    ]);
    const [invoiceNo, setInvoiceNo] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    // Initialize date state with today's date
    const [date, setDate] = useState(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(today.getDate()).padStart(2, '0');
        setInvoiceDate(`${year}-${month}-${day}`);
        return `${year}-${month}-${day}`;
    });
    const [paymentTerms, setPaymentTerms] = useState('0');
    const [dueDate, setDueDate] = useState('');
    const [notes, setNotes] = useState('');
    const [termsAndConditions, setTermsAndConditions] = useState('');
    const [additionalCharges, setAdditionalCharges] = useState([]);
    const [discount, setDiscount] = useState('');
    const [discountType, setDiscountType] = useState('%');
    const [amountReceived, setAmountReceived] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [fullyPaid, setFullyPaid] = useState(false);
    // const [tcs, setTcs] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        setDueDate(calculateDueDate(date, paymentTerms));
    }, [date, paymentTerms]);
        

    // Function to calculate due date
    const calculateDueDate = (selectedDate, terms) => {
        if (!selectedDate || !terms) {
            return "";
        }
        const dateObj = new Date(selectedDate);
        dateObj.setDate(dateObj.getDate() + parseInt(terms, 10));
        return dateObj.toISOString().split('T')[0];
    };

    // Handle date and payment terms change
    const handleDateChange = (e) => {
        const selectedDate = e.target.value;
        setDate(selectedDate);
        setInvoiceDate(selectedDate);
        setDueDate(calculateDueDate(selectedDate, paymentTerms));
    };

    const handlePaymentTermsChange = (e) => {
        const terms = e.target.value;
        setPaymentTerms(terms);
        setDueDate(calculateDueDate(date, terms));
    };

    const handleAddAdditionalCharge = () => {
        setAdditionalCharges([...additionalCharges, { label: '', value: '' }]);
    };

    const handleAdditionalChargeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedCharges = [...additionalCharges];
        updatedCharges[index] = { ...updatedCharges[index], [name]: value };
        setAdditionalCharges(updatedCharges);
    };

    const handleRemoveAdditionalCharge = (index) => {
        setAdditionalCharges(additionalCharges.filter((_, i) => i !== index));
    };


    const handleAddItem = () => {
        setItems([
            ...items,
            {
                item: '',
                qty: 1,
                discount: '',
                discountType: '%',
                hsnCode: '',
                unit: '',
                taxRate: '',
            },
        ]);
    };

    const handleRemoveItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };


    const handleFullyPaidChange = (e) => {
        setFullyPaid(e.target.checked);
        if (e.target.checked) {
            setAmountReceived('');
            setPaymentMode('');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!billTo || !items || items.length === 0 || !invoiceNo || !date || !paymentTerms) {
            setError("Please fill in all required fields.");
            return;
        }

        const saleData = {
            billTo,
            items,
            invoiceNo,
            date,
            paymentTerms,
            dueDate,
            notes,
            termsAndConditions,
            additionalCharges,
            discount,
            discountType,
            amountReceived,
            paymentMode,
            fullyPaid,
            // tcs
        };

    }
    const handleBack = () => {
        navigate(-1);
    };
    return (
        <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-6">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <div className="flex items-center space-x-4">
                        <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
                            <ArrowLeft className="h-6 w-6" />
                        </button>
                        <h2 className="text-2xl font-bold text-gray-800">Add Sale</h2>
                    </div>
                </div>

                <SaleForm
                    billTo={billTo}
                    setBillTo={setBillTo}
                    items={items}
                    setItems={setItems}
                    invoiceNo={invoiceNo}
                    setInvoiceNo={setInvoiceNo}
                    date={date}
                    handleDateChange={handleDateChange}
                    paymentTerms={paymentTerms}
                    handlePaymentTermsChange={handlePaymentTermsChange}
                    dueDate={dueDate}
                    notes={notes}
                    setNotes={setNotes}
                    termsAndConditions={termsAndConditions}
                    setTermsAndConditions={setTermsAndConditions}
                    additionalCharges={additionalCharges}
                    handleAddAdditionalCharge={handleAddAdditionalCharge}
                    handleAdditionalChargeChange={handleAdditionalChargeChange}
                    handleRemoveAdditionalCharge={handleRemoveAdditionalCharge}
                    handleAddItem={handleAddItem}
                    handleRemoveItem={handleRemoveItem}
                    discount={discount}
                    setDiscount={setDiscount}
                    discountType={discountType}
                    setDiscountType={setDiscountType}
                    amountReceived={amountReceived}
                    setAmountReceived={setAmountReceived}
                    paymentMode={paymentMode}
                    setPaymentMode={setPaymentMode}
                    fullyPaid={fullyPaid}
                    handleFullyPaidChange={handleFullyPaidChange}
                    // tcs={tcs}
                    // setTcs={setTcs}
                    handleSubmit={handleSubmit}
                    error={error}
                />
            </div>
        </div>
    );

};

export default AddSale;